var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-md-center"},[_c('v-avatar',{attrs:{"color":"grey lighten-4","size":"120"}},[_c('img',{attrs:{"src":_vm.publicPath('/img/avatar.jpg'),"alt":"image of Joseph D Jordan"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }